import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class LogicCssClass extends DesigntimeComponent {
    static staticName = "Logic: CssClass";
    static staticId = "logicCssClass";
    hasRuntimeView = false;

    constructor(identifyer) {
        super(identifyer, 1);

        this.values = {
            trueClass: { value: "bg-primary", dontTranslate: true },
            falseClass: { value: "bg-secondary", dontTranslate: true }
        };

        this.params = {
            parameter1: { key: "url:monthlySpending", value: 0 }
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));
        return $(`<div class='${this.type}'></div>`);
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == this.id)
            return;

        if (this.params.parameter1.key != eventParams.key) {
            return;
        }

        let res = this.values.trueClass.value;
        if (!eventParams.value)
            res = this.values.falseClass.value;

        this.eventBroker.fireValueChanged(this.id, "class", res);
    }

    output = [
        { name: "class", type: "string" }
    ];
}

export { LogicCssClass }
